export default {
    userSignin: {
        title: 'BCG Formula 1<br/>simulator',
        input: {
            code: 'Enter your code',
            username: 'Enter your name'
        },
        btn: 'GO'
    },
    nick: {
        title: 'Set up your nickname',
        input: {
            nickname: 'Enter your nickname'
        },
        btn: 'START PLAYING'
    },
    mc: {
        title: 'MC Sign in',
        input: {
            username: 'Username',
            password: 'Password'
        },
        btn: 'Go'
    },
    superadmin: {
        title: 'Admin Sign in',
        input: {
            username: 'Username',
            password: 'Password'
        },
        btn: 'Go'
    },
    signout: 'Sign out',
    input: {
        raceCode: {
            label: 'Race Code',
            placeholder: 'Enter your race code'
        },
        name: {
            label: 'Name',
            placeholder: 'Enter your name'
        }
    },
    btn: {
        signin: 'Go'
    }
}



// WEBPACK FOOTER //
// src/lang/locales/en/auth.js